require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-astrocoders-bs-react-native-vector-icons.json") })
        }
      }, "path---package-unpublished-astrocoders-bs-react-native-vector-icons");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-astrocoders-bs-react-native-vector-icons!./.cache/json/package-unpublished-astrocoders-bs-react-native-vector-icons.json
// module id = 931
// module chunks = 231608221292675